import { ROLE_OPTIONS } from "../helpers/roles";
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Register = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('user');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('/api/auth/register', {
                username,
                password,
                role
            });

            if (response.data.message === "Користувача створено") {
                navigate('/login');
            }
        } catch (err) {
            setError(err.response?.data?.error || "Помилка реєстрації");
        }
    };

    return (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center w-100 px-3 py-5">
            <form
                onSubmit={handleRegister}
                className="p-4 border rounded bg-white"
                style={{ width: '100%', maxWidth: '400px' }}
            >
                <h4 className="mb-4 text-center">Регистрация</h4>

                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Имя пользователя"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>

                <div className="mb-3">
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Пароль"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="mb-3">
                    <select
                        className="form-select"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                    >
                        {ROLE_OPTIONS.filter((r) => r.value !== "showroom_manager").map((r) => (
                            <option key={r.value} value={r.value}>
                                {r.label}
                            </option>
                        ))}
                    </select>
                </div>

                {error && <p className="text-danger mb-2">{error}</p>}

                <button type="submit" className="btn btn-dark w-100">
                    Зарегистрироваться
                </button>
            </form>
        </div>
    );
};

export default Register;
